<template>
  <BarChart
    :request-status="requestStatus"
    :categories="categories"
    :series="series"
    :title="title"
    :item-id="itemId"
    :card-options="cardOptions"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import BarChart from '@/components/cards/models/BarChart';
import { ENTITIES, SAC_STATUS_FIELDS, POINTS_PARSER } from '@/services/charts-service';
import EventBus from '@/utils/event-bus';
import { mapActions, mapGetters } from 'vuex';
import proprietaryModel from '@/mixins/proprietary-model';
import highchartsBasics from '@/mixins/highcharts-basics';
import { getTitlesAndChannels } from '@/utils/pages';
import colors from '@/utils/colors';

export default {
  name: 'SacTreatmentsByPage',
  components: {
    BarChart,
  },
  mixins: [
    proprietaryModel,
    highchartsBasics,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    isExpandedCard: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      rawData: {},
      cardOptions: {
        plotOptions: {
          series: {
            stacking: 'normal',
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters('dashboard', [
      'pages',
    ]),
    data() {
      if (this.rawData.points) {
        return this.isExpandedCard ? this.rawData.points : this.rawData.points.slice(0, this.maxItemsToBeDisplayed);
      }

      return [];
    },
    pageIds() {
      return this.data.map(({ coordinates }) => coordinates.pageId);
    },
    categories() {
      return getTitlesAndChannels(this.pageIds, this.pages);
    },
    series() {
      if (!this.rawData?.points) {
        return [];
      }

      return [
        {
          name: 'Atendimentos',
          color: colors.defaultSerieColor,
          data: this.data.map(({ value }) => value),
        },
      ];
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getChartsService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getChartsService({
        itemId: this.itemId,
        method: 'getAggregatedData',
        entity: ENTITIES.SAC_STATUS,
        points_parser: POINTS_PARSER.COORDINATES,
        params: {
          grouping: [SAC_STATUS_FIELDS.pageId],
          label: 'treatments',
          sorting: 'desc',
          sortFields: ['treatments'],
        },
      })
        .then((response) => {
          this.rawData = response;

          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch((err) => {
          console.error(err);
          this.requestStatus = 'error';
        });
    },
  },
};
</script>
